// Mock for @react-native-google-signin/google-signin on web
// This prevents the native module from being loaded on web
import React from 'react';
import { View, Text } from 'react-native';

export const GoogleSignin = {
  configure: () => {},
  hasPlayServices: async () => true,
  signIn: async () => {
    throw new Error('Google Sign-In is not supported on web. Please use signInWithPopup instead.');
  },
  signOut: async () => {},
  isSignedIn: async () => false,
  getCurrentUser: async () => null,
  getTokens: async () => ({ idToken: null, accessToken: null }),
  revokeAccess: async () => {},
};

export const statusCodes = {
  SIGN_IN_CANCELLED: 'SIGN_IN_CANCELLED',
  IN_PROGRESS: 'IN_PROGRESS',
  PLAY_SERVICES_NOT_AVAILABLE: 'PLAY_SERVICES_NOT_AVAILABLE',
};

// Mock the native button component
export const GoogleSigninButton = (props: any) => {
  return React.createElement(View, { style: { display: 'none' } });
};

// Mock the RNGoogleSigninButton native component
export const RNGoogleSigninButton = (props: any) => {
  return React.createElement(View, { style: { display: 'none' } });
};

export default { GoogleSignin, statusCodes, GoogleSigninButton };
